import { useEffect, useState } from 'react';
import { sendApiRequest } from '../../../api/request';
import './imagesPage.css';

export default function ImagesPage() {
    const [action, setAction] = useState('upload');
    const [file, setFile] = useState(null);
    const [filename, setFilename] = useState('');
    const [message, setMessage] = useState('');
    const [allImages, setAllImages] = useState([]);
    const [viewImage, setViewImage] = useState('');

    const fetchAllImages = async () => {
        try {
            const images = await sendApiRequest('GET', '/admin/files/all');
            setAllImages(images);
        } catch (err) {
            setMessage(err?.message ?? 'Failed to fetch images');
        }
    };

    useEffect(() => {
        fetchAllImages();
    }, []);

    const handleAction = async () => {
        setMessage('');
        try {
            if (action === 'upload') {
                if (!file) return setMessage('Please select a file to upload.');
                const formData = new FormData();
                formData.append('file', file);
                const uploaded = await sendApiRequest('POST', '/admin/files/upload', formData);
                setMessage(`Uploaded: ${uploaded}`);
                setFile(null);
            } else if (action === 'delete') {
                if (!filename) return setMessage('Please select a filename to delete.');
                await sendApiRequest('DELETE', `/admin/files/delete/${filename}`);
                setMessage(`Deleted: ${filename}`);
                setFilename('');
            } else if (action === 'view') {
                if (!filename) return setMessage('Please select a filename to view.');
                setViewImage(`${process.env.REACT_APP_BACKEND_URL}/uploads/${filename}`);
            }
            fetchAllImages();
        } catch (err) {
            setMessage(err?.message ?? 'Request failed');
        }
    };

    return (
        <div className="images-container">
            <h2>Manage Images</h2>

            <div className="images-actions">
                <select value={action} onChange={(e) => setAction(e.target.value)}>
                    <option value="upload">Upload</option>
                    <option value="delete">Delete</option>
                    <option value="view">View</option>
                </select>

                {action === 'upload' && (
                    <input type="file" onChange={(e) => setFile(e.target.files[0])} />
                )}

                {(action === 'delete' || action === 'view') && (
                    <select value={filename} onChange={(e) => setFilename(e.target.value)}>
                        <option value="">-- Select image --</option>
                        {allImages.map((img) => (
                            <option key={img} value={img}>{img}</option>
                        ))}
                    </select>
                )}

                <button className="btn-primary" onClick={handleAction}>
                    {action === 'upload' ? 'Upload' : action === 'delete' ? 'Delete' : 'View'}
                </button>
            </div>

            {viewImage && (
                <div className="image-preview">
                    <img src={viewImage} alt="Preview" />
                </div>
            )}

            <div className="images-table-container">
                <table className="images-table">
                    <thead>
                        <tr>
                            <th>Filename</th>
                        </tr>
                    </thead>
                    <tbody>
                        {allImages.map((img, idx) => (
                            <tr key={idx}>
                                <td>{img}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {message && <p className="images-message">{message}</p>}
        </div>
    );
}
